/**
 * Trust strip — 3 quick reassurance bullets right under the hero.
 *
 * No CTA, no big claims — just three short statements that answer
 * "is my money safe / does this work / can I see what's happening?"
 */
import { useTranslation } from 'react-i18next'
import { Lock, Activity, FileText } from 'lucide-react'

export function TrustStrip() {
  const { t } = useTranslation('landing')

  const items = [
    { key: 'non_custodial', icon: <Lock     size={18} className="text-fire"  /> },
    { key: 'always_on',     icon: <Activity size={18} className="text-pulse" /> },
    { key: 'transparent',   icon: <FileText size={18} className="text-sky"   /> },
  ] as const

  return (
    <section className="px-6 border-y border-line bg-surface/40">
      <div className="max-w-6xl mx-auto grid sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-line">
        {items.map(({ key, icon }) => (
          <div key={key} className="px-5 py-6 flex items-start gap-3">
            <div className="shrink-0 mt-0.5">{icon}</div>
            <div>
              <div className="text-sm font-semibold">
                {t(`trust.${key}.title`)}
              </div>
              <div className="text-xs text-textDim mt-1 leading-relaxed">
                {t(`trust.${key}.body`)}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
